<form (ngSubmit)="onSubmit()" [formGroup]="form" novalidate>
  <section>
    <mat-form-field>
      <mat-label>First Name</mat-label>
      <input formControlName="first_name" matInput required />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Last Name</mat-label>
      <input formControlName="last_name" matInput required />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Email</mat-label>
      <input formControlName="email" matInput required />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Admin Email</mat-label>
      <input formControlName="admin_email" matInput type="email" />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Branch Number</mat-label>
      <input formControlName="branch_number" matInput required />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Employee Number</mat-label>
      <input formControlName="employee_number" matInput required />
    </mat-form-field>
    @if (role !== 'retired-user-admin') {
      <mat-form-field>
        <mat-label>Status</mat-label>
        <mat-select formControlName="status" required>
          <mat-option value="working-partner"> Working Partner </mat-option>
          <mat-option value="retired-partner"> Retired Partner </mat-option>
          <mat-option value="leaver-benefits"> Leaver Benefits </mat-option>
          <mat-option value="benefits"> Benefits in Redundancy </mat-option>
          <mat-option value="inherited"> Inherited </mat-option>
          <mat-option value="deactivated"> Deactivated </mat-option>
        </mat-select>
      </mat-form-field>
    }
  </section>
  <section align="end">
    <button
      [disabled]="!form.valid || loading"
      mat-button
      matTooltip="Save partner details"
      type="submit"
      >
      <mat-icon>save</mat-icon>
      Save
    </button>
  </section>
</form>
